import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetCompPointsConversionDetails = () => {
    const send = useGenericSend();

    return useCallback(
        async (): Promise<Types.IGetCompPointsConversionDetailsResponseData> => {
            const { data } = await send<TServerSendRequest, Types.IGetCompPointsConversionDetailsResponseData>({
                ID: 35616,
                responses: [35617, 35618],
                description: 'Get loyalty points conversion details',
                errorLevel: 1
            });

            return data;
        }, [
            send
        ]);
};
